export const DEFAULT_CHATBOX = {
  greeting: "Hi 👋 How can we help you today?",
  primary_color: "#121e71",
  secondary_color: "#5c6ce4",
  isDefaultChatBox: true,
  logo: "/default-chat-logo.png",
  position: "right",
  x_axis: 12,
  y_axis: 20,
  show_property_type_filter: true,
};

export const initialLeadData = {
  // Budget
  budget_exact: 30,
  budget_primary_buffer: 20,
  budget_secondary_buffer: 10,

  // Contact
  mobile: 25,
  email: 15,

  // Timeline
  timeline_0_3: 15,
  timeline_3_6: 10,
  timeline_above_6: 0,

  // Funding
  funding_ready: 10,
  funding_need_loan: 5,
  funding_unknown: 0,

  // Qualification
  intent: 5,

  // Property
  location: 3,
  property_type: 3,
  unit_type: 5,

  // Buyer
  authority: 5,
  send_detail: 2,
  specific_requirement: 2,
  purchase_reason: 2,
};

export const PROPERTY_TYPES = [
  "apartment",
  "villa",
  "plot",
];

export const UNIT_TYPES = [
  "studio",
  "1bhk",
  "1.5bhk",
  "2bhk",
  "2.5bhk",
  "3bhk",
  "3.5bhk",
  "4bhk",
  "4.5bhk",
  "5bhk",
  "5.5bhk",
  "6bhk",
  "6.5bhk",
  "7bhk",
  "7.5bhk",
  "8bhk",
  "8.5bhk",
  "duplex",
  "penthouse",
]